import { Select } from "antd";
import { TenantTipoEstrutura } from "core/resources/enums/tenant";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

const { Option } = Select;

function SelectTipoEstrutura({ ...rest }: SelectBaseAntdProps) {
  return (
    <SelectBaseAntd size="large" placeholder="Tipo de Estrutura" {...rest}>
      <Option value={TenantTipoEstrutura.Horizontal}>Horizontal</Option>
      <Option value={TenantTipoEstrutura.Vertical}>Vertical</Option>
    </SelectBaseAntd>
  );
}

export default SelectTipoEstrutura;
